exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-zoom[data-v-f5135308] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 5;\n  background: #fff;\n}\n.media-zoom__close[data-v-f5135308] {\n  position: absolute;\n  right: 20px;\n  top: 150px;\n  -webkit-transform: translateY(-50%);\n      -ms-transform: translateY(-50%);\n          transform: translateY(-50%);\n  z-index: 1;\n}\n", ""]);

// exports
